import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, GetLoginCredentialDb, getModValue, linksUrl } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faPlus,
  faReceipt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, setDetailParams, setNewEntryMode } from "../../state/masterItemEntrySlice"

const MasterItemEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { token, user } = useSelector((state) => state.auth)
  const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
  let [itemToDelete, setItemToDelete] = useState("")

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard.tradingDashboard)
    disapatch(resetDetailParams())
  }, [])

  const {
    isError,
    isPending,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.masterItemEntry.fetch,
    queryKey: "Master Item List",

  })
  const funFilterData = () => {
    filterData({
      data: {
        compcode: compCode.join(","),
      }
    })

  }

  useEffect(() => {
    funFilterData();
  }, [])



  const onSuccessDelete = (data) => {
    setItemToDelete("")
    
    if (data && data.length > 0) {
      if (data[0].ref == 1) {
        toast.error("Entry can't be delete as one/more taka of this challan are in used/delivered ", {
          "position": "top-center",
          "className": "toast-error",
        })
      }
      else {
        toast.success("deleted successfully", {
          position: "top-center"
        })
        funFilterData();
      }

    }
  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.masterItemEntry.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalDenier = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Total_Denier",
      }),
    [data]
  )
  let totalWeight = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Total_PerMtrWeight",
      }),
    [data]
  )
   let totalWastage = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Total_Wastage",
      }),
    [data]
  )

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "MItem_Desc",
    "Total_Denier",
    "Total_PerMtrWeight",
    "Total_Wastage"
  ]
  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
     {
      name: "Gray Item",
      uid: "MItem_Desc",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    
    },
    {
      name: "Denier",
      uid: "Total_Denier",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalDenier,
      },
    },
    {
      name: "Weight/100 Mtr",
      uid: "Total_PerMtrWeight",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.left,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalWeight,
      },
    },
    {
      name: "Wastage",
      uid: "Total_Wastage",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.left,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalWastage,
      },
    },
   
  ]
  const exportColumns = [

    {
      name: "Gray Item",
      uid: "MItem_Code",
    },
    {
      name: "Denier",
      uid: "Total_Denier",
    },
    {
      name: "Weight/100 Mtr",
      uid: "Total_PerMtrWeight",
    },
    {
      name: "Wastage",
      uid: "Total_Wastage",
    },
    
    
  ]

  let downloadDataFooter = {
    MItem_Desc: "",
    Total_Denier:  " Total:" + totalDenier,
    Total_PerMtrWeight: " Total:" + totalWeight,
    Total_Wastage: " Total:" + totalWastage,
  
   
  }

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const handleConfirmBox = (data) => {
    if (data) {

      FndeleteNote({
        data: {
          comp_code:0,
          mitem_code: itemToDelete.MItem_Code,
        }
      })
    }
    else {
      setItemToDelete("")
    }

  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        disapatch(setDetailParams(row))
        disapatch(setNewEntryMode(false))
        navigate(linksUrl.masterItemEntry.createMasterItemEntry)
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {

        setItemToDelete(row)
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  const handleAddNew = () => {
    disapatch(resetDetailParams())
    navigate(linksUrl.masterItemEntry.createMasterItemEntry)
  }



  return (
    <div>

      {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}

      <MainContainer
        pageName="Master Item Constuction"
        info={[]}
        breadcrumbs={["Master","Item", "Master Item Constuction"]}
      >
        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          showAdvanceFilter={false}
          downloadFileName="MasterItem-List"
          id="MItem_Code"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default MasterItemEntryMaster
